import { useEffect } from "react";
import { CSVLink } from "react-csv";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { fetchEASSummary } from "redux/reducers/EASSlice";
import { uacEISReportCSVHeaders } from "utils/AssetsData";
import { WHITELABEL } from "utils/Constants";

const CSVLinkButton = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const whitelabel = useAppSelector(state => state.properties.whiteLabel);
  const { docData } = useAppSelector(state => state.eas);

  const columnHeaders = whitelabel === WHITELABEL.utas ? [] : uacEISReportCSVHeaders;

  useEffect(() => {
    dispatch(fetchEASSummary());
  }, []);

  return (
    <div style={{ float: "right", marginBottom: "10px" }}>
      <CSVLink
        data={docData ?? []}
        headers={columnHeaders}
        filename={`${t("easApplications.csv.fileTitle")}.csv`}
        aria-label="Export as CSV file for EIS report"
        className={["ant-btn ant-btn-primary"].join(" ")}
      >
        {t("easApplications.csv.btnTitle")}
      </CSVLink>
    </div>
  );
};

export default CSVLinkButton;
